module.exports = __webpack_public_path__ + "static/media/iconWhiteApollo.59349338.png";